import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  callWithAuth,
  getActiveCourseFilters,
  putActiveCourseFilters,
  Filters,
} from "@/api/Api";

export const useActiveCourseFilters = () => {
  const queryClient = useQueryClient();

  const filtersQuery = useQuery({
    queryKey: ["activeCourseFilters"],
    queryFn: () => callWithAuth(getActiveCourseFilters),
  });

  const updateFiltersMutation = useMutation({
    mutationFn: (data: Filters) => putActiveCourseFilters(data),
    onSuccess: (_, variables) => {
      queryClient.setQueryData(["activeCourseFilters"], variables);
      filtersQuery.refetch();
    },
  });

  const setFilters = (filters: Filters) => {
    updateFiltersMutation.mutate(filters);
  };

  const clearFilters = () => {
    updateFiltersMutation.mutate({
      selectedLevel: 0,
      selectedTopics: [],
    });
  };

  return {
    selectedLevel: filtersQuery.data?.selectedLevel ?? 0,
    selectedTopics: filtersQuery.data?.selectedTopics ?? [],
    setFilters,
    clearFilters,
    isLoading: filtersQuery.isLoading,
  };
};
